/*
 * Just some stubbable functions for testing purposes.
 */
export const windowMocks = {
  matchMedia: queryString => {
    return window.matchMedia(queryString);
  }
};
export function matchMedia(queryString) {
  return windowMocks.matchMedia(queryString);
}